module.exports = __webpack_public_path__ + "img/q34.fcd1bdff.png";